<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

  export default {
    name: 'app',
  };
</script>

<style lang="scss">
  #app {
    color: #101010;
  }

  .Container {
    // min-width: 768px;
    // margin-left: 68px;
    // margin-right: 68px;
    width: 1220px;
    margin: 0 auto;
    font-family: Verdana, sans-serif;
  }

  .Content {
    // margin-top: 30px;
    // a {
    //   color: #101010;
    // }
  }

  #google_translate_element{
    .goog-te-gadget-simple{
      background-color: black !important;
      border:none;
    }
    .goog-te-gadget-simple .goog-te-menu-value {
      color: white !important;
    }
  }

  @media screen and (min-width: 320px )and (max-width:375px) {
    html{
      font-size: calc(100vw / 375 * 100) !important;
      font-family: SFProText-regular, sans-serif;
    }
  }

  @media screen and (min-width: 376px )and (max-width:414px) {
    html{
      font-size: calc(100vw / 375 * 100) !important;
    }
  }

  @media screen and (min-width: 415px )and (max-width:1219px) {
    html{
      font-size: calc(100vw / 375 * 100) !important;
      // font-size: calc(414px / 375 * 100) !important;
    }
  }

  @media screen and (max-width: 1388px) {
    // .Container {
    //   margin-left: 10px;
    //   margin-right: 10px;
    // }
  }
</style>
